module.exports = __webpack_public_path__ + "static/media/students.7b28734c.png";